import { Swiper } from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export default function initCarouselRecommendedProducts() {
  const containers = document.querySelectorAll(".swiper-recommended-products");
  if (!containers.length) return;

  containers.forEach((container) => {
    new Swiper(container, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      allowTouchMove: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
  });
}
